import React from 'react';
import { SectionCard, SectionHeader, SectionIconWrap, SectionTitle } from './Styles';
import type { AnalysisCardProps } from './types';

const AnalysisCard: React.FC<AnalysisCardProps> = ({
  title,
  icon,
  iconColor,
  children,
}) => (
  <SectionCard>
    <SectionHeader>
      <SectionIconWrap $color={iconColor}>{icon}</SectionIconWrap>
      <SectionTitle>{title}</SectionTitle>
    </SectionHeader>
    {children}
  </SectionCard>
);

export default React.memo(AnalysisCard);
